export default {
  data() {
    return {
      isOpen: false,
    }
  },
  props: {
    label: {
      type: String,
    },
    links: {
      type: Array,
    },
  },

  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
    },

    close() {
      this.isOpen = false
    },

    click() {
      if (this.isOpen) this.close()
    },
  },

  mounted() {
    this.$nextTick(() => {
      window.addEventListener('click', this.click)
    })
  },

  beforeDestroy() {
    window.removeEventListener('click', this.click)
  },

  beforeUpdate() {
    const locale = this.$i18n.locale
    const handtalk = document.getElementById('handtalkId')
    const ht = document.getElementsByClassName('ht-skip')[0]

    if (locale !== 'pt-br' && handtalk) {
      handtalk.remove()
      ht.remove()
    } else if (locale === 'pt-br' && !handtalk) {
      const handtalkScript = document.createElement('script')
      handtalkScript.src = 'https://plugin.handtalk.me/web/latest/handtalk.min.js'
      handtalkScript.id = 'handtalkId'

      handtalkScript.onload = () => {
        var ht = new HT({ token: '6c87e51d3de96e073573a3c3929c4f2f', avatar: 'MAYA' })
      }

      document.body.appendChild(handtalkScript)
    }
  },
}
